import { useEffect } from "react";
import { checkNetworkCache } from "../api/CacheHolder";
import { setLocalStorageItem } from "../utils/storage/storage";
import { consoleLogInfo } from "../utils/console";
import { msToTimeLabel } from "../utils/time";
import { STORAGE_KEY_CONTENT_CACHE_LAST_CHECK } from "../utils/storage/storage.constants";
import { TIMEOUT_DAY } from "../constants";
import {checkContentVersionRequest} from "../api/content/common";
import {isProduction} from "../utils/assembly";

const scope = "Content version";
const MS_FREQUENCY = TIMEOUT_DAY;

const IS_CONSOLE_LOGS = isProduction() || false;

const useCheckContentVersion = (isEnabled = true) => {
  useEffect(() => {
    if (!isEnabled) {
      return undefined;
    }

    let timerId;

    const checkAfter = (ms) => {
      if (IS_CONSOLE_LOGS) {
        consoleLogInfo(scope, `Check in ${msToTimeLabel(ms)}`);
      }

      timerId = setTimeout(async () => {
        if (IS_CONSOLE_LOGS) {
          consoleLogInfo(scope, "Checking...");
        }

        setLocalStorageItem(STORAGE_KEY_CONTENT_CACHE_LAST_CHECK, Date.now());

        const contentVersionServer = await checkContentVersionRequest();
        checkNetworkCache(contentVersionServer, true, IS_CONSOLE_LOGS);

        checkAfter(MS_FREQUENCY);
      }, ms);
    };

    checkAfter(0);

    return () => {
      clearTimeout(timerId);
    };
  }, [isEnabled]);
};

export default useCheckContentVersion;
